














import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component<Trashcan>({})
export default class Trashcan extends Vue {}
